var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRobot500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13536",
    "data-name": "Group 13536",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 259.546,
    height: 450.164,
    viewBox: "0 0 259.546 450.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31753",
    "data-name": "Rectangle 31753",
    width: 259.546,
    height: 450.164,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31688",
    "data-name": "Rectangle 31688",
    width: 13.564,
    height: 12.724,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31689",
    "data-name": "Rectangle 31689",
    width: 16.68,
    height: 9.114,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31690",
    "data-name": "Rectangle 31690",
    width: 15.585,
    height: 5.838,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31691",
    "data-name": "Rectangle 31691",
    width: 54.453,
    height: 19.235,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31692",
    "data-name": "Rectangle 31692",
    width: 12.453,
    height: 16.407,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31693",
    "data-name": "Rectangle 31693",
    width: 23.823,
    height: 84.22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31694",
    "data-name": "Rectangle 31694",
    width: 4.123,
    height: 88.237,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31695",
    "data-name": "Rectangle 31695",
    width: 12.685,
    height: 45.873,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31696",
    "data-name": "Rectangle 31696",
    width: 25.61,
    height: 7.824,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31703",
    "data-name": "Rectangle 31703",
    width: 48.992,
    height: 20.112,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31704",
    "data-name": "Rectangle 31704",
    width: 68.828,
    height: 24.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31705",
    "data-name": "Rectangle 31705",
    width: 66.556,
    height: 22.758,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31706",
    "data-name": "Rectangle 31706",
    width: 7.514,
    height: 12.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31707",
    "data-name": "Rectangle 31707",
    width: 66.05,
    height: 29.308,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31708",
    "data-name": "Rectangle 31708",
    width: 35.986,
    height: 40.074,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31709",
    "data-name": "Rectangle 31709",
    width: 0.658,
    height: 29.814,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31711",
    "data-name": "Rectangle 31711",
    width: 22.992,
    height: 18.575,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31712",
    "data-name": "Rectangle 31712",
    width: 42.26,
    height: 25.766,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31713",
    "data-name": "Rectangle 31713",
    width: 34.959,
    height: 62.498,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31714",
    "data-name": "Rectangle 31714",
    width: 34.481,
    height: 18.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31715",
    "data-name": "Rectangle 31715",
    width: 40.933,
    height: 4.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31716",
    "data-name": "Rectangle 31716",
    width: 35.209,
    height: 3.637,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31717",
    "data-name": "Rectangle 31717",
    width: 34.067,
    height: 3.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31718",
    "data-name": "Rectangle 31718",
    width: 82.055,
    height: 24.417,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31719",
    "data-name": "Rectangle 31719",
    width: 8.664,
    height: 32.653,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31721",
    "data-name": "Rectangle 31721",
    width: 12.781,
    height: 6.416,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31723",
    "data-name": "Rectangle 31723",
    width: 31.139,
    height: 23.392,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31724",
    "data-name": "Rectangle 31724",
    width: 5.966,
    height: 5.685,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31725",
    "data-name": "Rectangle 31725",
    width: 5.222,
    height: 5.489,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31726",
    "data-name": "Rectangle 31726",
    width: 5.128,
    height: 7.311,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31727",
    "data-name": "Rectangle 31727",
    width: 4.394,
    height: 6.887,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31728",
    "data-name": "Rectangle 31728",
    width: 3.517,
    height: 8.037,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31729",
    "data-name": "Rectangle 31729",
    width: 2.806,
    height: 7.408,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31730",
    "data-name": "Rectangle 31730",
    width: 3.383,
    height: 8.204,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31731",
    "data-name": "Rectangle 31731",
    width: 3.355,
    height: 7.358,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31732",
    "data-name": "Rectangle 31732",
    width: 9.687,
    height: 2.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31733",
    "data-name": "Rectangle 31733",
    width: 8.529,
    height: 2.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31734",
    "data-name": "Rectangle 31734",
    width: 13.626,
    height: 24.31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31735",
    "data-name": "Rectangle 31735",
    width: 13.416,
    height: 22.854,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31740",
    "data-name": "Rectangle 31740",
    width: 7.153,
    height: 3.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31741",
    "data-name": "Rectangle 31741",
    width: 6.631,
    height: 3.028,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31742",
    "data-name": "Rectangle 31742",
    width: 8.317,
    height: 2.533,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31743",
    "data-name": "Rectangle 31743",
    width: 7.619,
    height: 1.653,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31744",
    "data-name": "Rectangle 31744",
    width: 8.381,
    height: 2.254,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31745",
    "data-name": "Rectangle 31745",
    width: 7.576,
    height: 2.045,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31746",
    "data-name": "Rectangle 31746",
    width: 6.917,
    height: 5.85,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31747",
    "data-name": "Rectangle 31747",
    width: 6.084,
    height: 5.685,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31748",
    "data-name": "Rectangle 31748",
    width: 5.181,
    height: 8.751,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31749",
    "data-name": "Rectangle 31749",
    width: 2.889,
    height: 8.52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31750",
    "data-name": "Rectangle 31750",
    width: 24.699,
    height: 8.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31751",
    "data-name": "Rectangle 31751",
    width: 17.081,
    height: 19.243,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13535",
    "data-name": "Group 13535",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13534",
    "data-name": "Group 13534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13533",
    "data-name": "Group 13533",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39572",
    "data-name": "Path 39572",
    d: "M172.077,290.033c-1.354.579-3.371.654-6.546-.94a11.052,11.052,0,0,1-6.218-10.258,14.448,14.448,0,0,1,2.047-.919c.237-.087.472-.161.7-.229a11.948,11.948,0,0,1,5.192-.477c4.03,2.658,5.666,4.726,5.827,7.392a9.7,9.7,0,0,1-.2,2.473,24.159,24.159,0,0,1-.8,2.958",
    transform: "translate(-64.751 -112.629)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13355",
    "data-name": "Group 13355",
    transform: "translate(94.562 165.058)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13354",
    "data-name": "Group 13354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13353",
    "data-name": "Group 13353",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39573",
    "data-name": "Path 39573",
    d: "M172.077,290.427c-1.354.579-3.371.654-6.546-.94a11.052,11.052,0,0,1-6.218-10.258,14.449,14.449,0,0,1,2.047-.919c.237-.087.472-.161.7-.229a12.707,12.707,0,0,1,6.3,2.666,12.274,12.274,0,0,1,4.516,6.723,24.159,24.159,0,0,1-.8,2.958",
    transform: "translate(-159.313 -278.081)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39574",
    "data-name": "Path 39574",
    d: "M169.364,266.278l-15.737,21.353,3.037,2.374L171.847,268.7Z",
    transform: "translate(-62.44 -108.226)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39575",
    "data-name": "Path 39575",
    d: "M176.546,270.655l-14.537,22.187,3.163,2.2,13.987-22.112Z",
    transform: "translate(-65.847 -110.005)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39576",
    "data-name": "Path 39576",
    d: "M132.69,306.817,121.8,327.2a1.349,1.349,0,0,0,2.2,1.534l13.878-17.584Z",
    transform: "translate(-49.438 -124.703)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39577",
    "data-name": "Path 39577",
    d: "M134.785,308.6l-10.942,20.384a1.372,1.372,0,0,0-.138.922,1.349,1.349,0,0,0,1.118-.445L138.7,311.879Z",
    transform: "translate(-50.268 -125.428)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39578",
    "data-name": "Path 39578",
    d: "M132.017,332.411c-3.869,7.173-12.408,10.164-19.073,6.678s-8.931-12.126-5.062-19.3,12.409-10.163,19.073-6.678,8.931,12.126,5.062,19.3",
    transform: "translate(-43.08 -126.67)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39579",
    "data-name": "Path 39579",
    d: "M133.1,333.182c-3.1,5.8-9.934,8.21-15.268,5.39s-7.145-9.805-4.047-15.6,9.934-8.21,15.268-5.39,7.145,9.805,4.047,15.6",
    transform: "translate(-45.63 -128.598)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39580",
    "data-name": "Path 39580",
    d: "M133.693,334.376c-2.793,5.235-8.885,7.45-13.606,4.948s-6.285-8.774-3.492-14.009,8.884-7.45,13.606-4.948,6.285,8.775,3.492,14.009",
    transform: "translate(-46.826 -129.792)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39581",
    "data-name": "Path 39581",
    d: "M163.945,293c-2.77,7.733-10.368,12.627-10.368,12.627l-13.391-9.6s1.165-8.184,7.066-14.033a16.6,16.6,0,0,1,5.33-3.611l.008,0a.6.6,0,0,1,.829.465c.41,2.47,1.635,6.634,5.271,8.646,4.072,2.254,5.664.586,6.622-1.38a.214.214,0,0,1,.407.1c-.011.2-.03.411-.056.62l0,.007a29.975,29.975,0,0,1-1.717,6.16",
    transform: "translate(-56.978 -113.124)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39582",
    "data-name": "Path 39582",
    d: "M396.332,303.1c.874,1.185,2.574,2.273,6.118,2.51a11.051,11.051,0,0,0,10.562-5.687,14.47,14.47,0,0,0-1.3-1.83c-.161-.2-.325-.378-.488-.553a11.941,11.941,0,0,0-4.233-3.044c-4.82.247-7.28,1.2-8.77,3.415a9.764,9.764,0,0,0-1.08,2.234,24.273,24.273,0,0,0-.81,2.955",
    transform: "translate(-161.085 -119.695)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13358",
    "data-name": "Group 13358",
    transform: "translate(235.247 176.83)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13357",
    "data-name": "Group 13357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13356",
    "data-name": "Group 13356",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39583",
    "data-name": "Path 39583",
    d: "M396.332,304.489c.874,1.185,2.574,2.273,6.118,2.51a11.051,11.051,0,0,0,10.562-5.687,14.47,14.47,0,0,0-1.3-1.83c-.161-.2-.325-.378-.488-.553a12.705,12.705,0,0,0-6.781-.9,12.281,12.281,0,0,0-7.3,3.5,24.274,24.274,0,0,0-.81,2.955",
    transform: "translate(-396.332 -297.914)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39584",
    "data-name": "Path 39584",
    d: "M411.146,281.237l2.733,26.385-3.821.506-2.278-26.065Z",
    transform: "translate(-165.738 -114.306)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39585",
    "data-name": "Path 39585",
    d: "M403.417,281.783l1.276,26.5-3.844.294-.839-26.15Z",
    transform: "translate(-162.58 -114.528)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39586",
    "data-name": "Path 39586",
    d: "M422.7,336.4l-.95,23.1a1.349,1.349,0,0,1-2.671.208l-3.042-22.193Z",
    transform: "translate(-169.093 -136.727)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39587",
    "data-name": "Path 39587",
    d: "M421.071,336.858l-.909,23.117a1.369,1.369,0,0,1-.348.865,1.347,1.347,0,0,1-.737-.95L416.035,337.7Z",
    transform: "translate(-169.093 -136.913)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39588",
    "data-name": "Path 39588",
    d: "M398.663,355.51c.043,8.264,5.207,14.938,11.535,14.9s11.424-6.758,11.381-15.022-5.207-14.938-11.535-14.905-11.424,6.759-11.381,15.023",
    transform: "translate(-162.032 -138.388)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39589",
    "data-name": "Path 39589",
    d: "M398.664,356.98c.037,7.259,4.183,13.122,9.261,13.1s9.163-5.931,9.126-13.191-4.183-13.122-9.261-13.1-9.163,5.931-9.126,13.191",
    transform: "translate(-162.033 -139.73)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39590",
    "data-name": "Path 39590",
    d: "M399.021,357.435c.036,6.978,3.71,12.617,8.208,12.594s8.113-5.7,8.078-12.678-3.71-12.617-8.208-12.594-8.113,5.7-8.078,12.678",
    transform: "translate(-162.178 -140.123)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39591",
    "data-name": "Path 39591",
    d: "M394.506,308.032c-1.535,8.07,2.531,16.141,2.531,16.141l16.409-1.481s3.146-7.645,1.027-15.678a16.6,16.6,0,0,0-2.763-5.815l0-.007a.6.6,0,0,0-.95-.02c-1.606,1.92-4.774,4.887-8.928,4.779-4.652-.123-5.179-2.368-5.007-4.548a.214.214,0,0,0-.4-.12c-.094.18-.182.369-.266.563l0,.007a29.98,29.98,0,0,0-1.644,6.18",
    transform: "translate(-160.202 -122.319)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13361",
    "data-name": "Group 13361",
    transform: "translate(235.923 178.632)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13360",
    "data-name": "Group 13360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13359",
    "data-name": "Group 13359",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39592",
    "data-name": "Path 39592",
    d: "M397.5,301.846l0,.007c-.146,1.577.2,4.843,5.6,4.935a11.729,11.729,0,0,0,9.958-5.588l0-.007a.6.6,0,0,0-.951-.02c-1.606,1.92-4.773,4.887-8.927,4.778-4.652-.122-5.179-2.368-5.008-4.548a.214.214,0,0,0-.4-.12c-.094.18-.183.369-.266.563",
    transform: "translate(-397.472 -300.951)",
    fill: "#1d1c1c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39593",
    "data-name": "Path 39593",
    d: "M399.526,362.788c.511,5.416,3.259,9.587,6.139,9.315s4.8-4.882,4.288-10.3-3.259-9.587-6.139-9.315-4.8,4.883-4.288,10.3",
    transform: "translate(-162.35 -143.261)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39594",
    "data-name": "Path 39594",
    d: "M406.762,335.848l-.95,23.1a1.349,1.349,0,0,1-2.671.208l-4.134-20.795Z",
    transform: "translate(-162.172 -136.502)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39595",
    "data-name": "Path 39595",
    d: "M403.782,370.939a1.615,1.615,0,1,0,2.01-1.083,1.615,1.615,0,0,0-2.01,1.083",
    transform: "translate(-164.086 -150.297)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39596",
    "data-name": "Path 39596",
    d: "M403.314,370.855a1.5,1.5,0,1,0,1.864-1,1.5,1.5,0,0,0-1.864,1",
    transform: "translate(-163.897 -150.296)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39597",
    "data-name": "Path 39597",
    d: "M403.322,371a1.2,1.2,0,1,0,1.5-.808,1.2,1.2,0,0,0-1.5.808",
    transform: "translate(-163.906 -150.439)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39598",
    "data-name": "Path 39598",
    d: "M320.043,672.061,318.458,689.4l12.951-15.115h30.582l10.9,11.561-3.632-18.24h-48.02Z",
    transform: "translate(-129.434 -271.343)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13364",
    "data-name": "Group 13364",
    transform: "translate(189.435 394.332)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13363",
    "data-name": "Group 13363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13362",
    "data-name": "Group 13362",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39599",
    "data-name": "Path 39599",
    d: "M319.15,683.586l11.017-14.314h32.691L373.6,682.278l-5.179-17.927H321.516Z",
    transform: "translate(-319.15 -664.351)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39600",
    "data-name": "Path 39600",
    d: "M347.783,424.622c-2.091,7.51-8.3,12.794-13.861,11.809-.195-.035-.389-.076-.576-.126a65.177,65.177,0,0,1,2.175-13.067,103.558,103.558,0,0,1,5.766-14.024c.067.01.138.019.206.031,5.564.985,8.381,7.871,6.29,15.377",
    transform: "translate(-135.485 -166.321)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39601",
    "data-name": "Path 39601",
    d: "M355.672,420.489a23.294,23.294,0,0,1-.316,2.426c-.059.344-.128.7-.207,1.043a24.909,24.909,0,0,1-.978,3.314c-2.351,6.343-6.9,10.443-11.045,9.524a4.785,4.785,0,0,1-.5-.137s.155-3.377.668-7.39c.144-1.115.313-2.279.516-3.436.076-.451.159-.9.248-1.339.138-.7.289-1.381.454-2.041.461-1.841.985-3.669,1.515-5.387,1.7-5.49,3.487-9.861,3.487-9.861.059.01.12.02.179.034,2.393.53,4.2,2.637,5.187,5.621a19.406,19.406,0,0,1,.792,7.627",
    transform: "translate(-139.257 -165.505)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13367",
    "data-name": "Group 13367",
    transform: "translate(204.037 247.357)",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13366",
    "data-name": "Group 13366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13365",
    "data-name": "Group 13365",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39602",
    "data-name": "Path 39602",
    d: "M356.652,424.361l-11.613,4.007c.138-.7.289-1.381.454-2.041.461-1.841.985-3.669,1.515-5.387,3.284-1.559,6.574-3.122,8.852-4.206a19.406,19.406,0,0,1,.792,7.627",
    transform: "translate(-344.274 -416.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39603",
    "data-name": "Path 39603",
    d: "M355.812,433.672c-.059.344-.128.7-.207,1.043a24.916,24.916,0,0,1-.978,3.314l-10.876,2c.145-1.115.313-2.278.516-3.435l11.544-2.918",
    transform: "translate(-343.751 -423.618)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39604",
    "data-name": "Path 39604",
    d: "M360.142,471.224a25.031,25.031,0,0,1-2.172,3.814c-2.028,3.2-4.74,7.2-4.74,7.2s-13.358-.117-13.709,0c-.221.072-3.89-2.815-6.85-5.417a22.355,22.355,0,0,1-3.7-3.725c-.823-1.638-2.667-33.476-2.667-33.476,22.059-14.845,22.806-47.02,22.806-47.02s7.572-5.8,7.748-5.8a.181.181,0,0,1,.007.031c.245,1.845,3.5,83.232,3.273,84.392",
    transform: "translate(-132.625 -157.211)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39605",
    "data-name": "Path 39605",
    d: "M373.216,632l-11.348-13.623h-33.1l-12.377,16.463,9.844-86.316,7.648-6.416H346.27l8.845,5.71Z",
    transform: "translate(-128.592 -220.335)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39606",
    "data-name": "Path 39606",
    d: "M376.071,713.351l-1.552,2.463-5.363,8.5H321.41L313.731,714.2l-.991-1.309,1.934-21.357,13.121-17.02H359.9l12.3,14.393Z",
    transform: "translate(-127.11 -274.151)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39607",
    "data-name": "Path 39607",
    d: "M375.2,723.331l-5.362,8.722H322.088l-7.679-10.374.943-10.667,13.121-17.457H360.58l12.3,14.762Z",
    transform: "translate(-127.789 -281.889)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39608",
    "data-name": "Path 39608",
    d: "M374.44,724.18l-4.938,8.032H325.529l-7.072-9.553.868-9.823,12.084-16.077h29.568l11.329,13.595Z",
    transform: "translate(-129.434 -283.19)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39609",
    "data-name": "Path 39609",
    d: "M393.679,632l-11.348-13.623h-.689l-14.91-76.269,8.845,5.71Z",
    transform: "translate(-149.055 -220.335)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39610",
    "data-name": "Path 39610",
    d: "M333.879,542.109l-4.54,76.269h-.575l-12.377,16.462,9.844-86.316Z",
    transform: "translate(-128.592 -220.335)",
    fill: "#bfc1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39611",
    "data-name": "Path 39611",
    d: "M360.483,498.039V529.15l-1.084.812a13.883,13.883,0,0,1-3.923,2.062q-.465.16-.94.279a13.973,13.973,0,0,1-7.028,0q-.475-.119-.94-.279a13.879,13.879,0,0,1-3.924-2.062l-1.084-.812V498.039l1.084-.812a13.972,13.972,0,0,1,3.924-2.062c.309-.1.623-.2.94-.275a13.972,13.972,0,0,1,7.028,0c.316.08.63.172.94.275a13.976,13.976,0,0,1,3.923,2.062Z",
    transform: "translate(-138.823 -200.96)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39612",
    "data-name": "Path 39612",
    d: "M358.9,495.165v36.859q-.465.16-.94.279a13.973,13.973,0,0,1-7.028,0q-.475-.119-.94-.279V495.165c.309-.1.623-.2.94-.275a13.972,13.972,0,0,1,7.028,0c.316.079.63.172.94.275",
    transform: "translate(-142.253 -200.96)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39613",
    "data-name": "Path 39613",
    d: "M358.608,494.889V532.3a13.972,13.972,0,0,1-7.028,0V494.889a13.972,13.972,0,0,1,7.028,0",
    transform: "translate(-142.896 -200.96)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39614",
    "data-name": "Path 39614",
    d: "M407.635,690.389c.737,6.137,1.024,7.694,3.659,7.378a3,3,0,0,0,.973-.29c2.068-1,3.317-4.281,2.872-7.989-.441-3.674-2.4-6.552-4.62-7.068a3.007,3.007,0,0,0-1.076-.065c-2.635.316-2.48,2.436-1.809,8.034",
    transform: "translate(-165.509 -277.327)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39615",
    "data-name": "Path 39615",
    d: "M411.308,690.186c.6,5.037.908,6.987,2.453,7.35a3.622,3.622,0,0,0,.833-.565c1.557-1.379,2.42-4.246,2.038-7.424-.376-3.137-1.859-5.695-3.671-6.7a3.658,3.658,0,0,0-.949-.371c-1.464.8-1.263,3.053-.7,7.707",
    transform: "translate(-167.002 -277.387)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39616",
    "data-name": "Path 39616",
    d: "M413.957,690.252c.493,4.1.785,6.159,1.714,6.974,1.557-1.38,2.42-4.246,2.038-7.424-.377-3.137-1.859-5.695-3.671-6.7-.758,1.107-.542,3.31-.081,7.148",
    transform: "translate(-168.079 -277.641)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13370",
    "data-name": "Group 13370",
    transform: "translate(193.684 235.389)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13369",
    "data-name": "Group 13369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13368",
    "data-name": "Group 13368",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39617",
    "data-name": "Path 39617",
    d: "M329.269,446.394l3.4,34.4a22.359,22.359,0,0,1-3.7-3.724c-.823-1.639-2.667-33.476-2.667-33.476,22.059-14.845,22.806-47.02,22.806-47.02s7.806,26-19.846,49.822",
    transform: "translate(-326.309 -396.572)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13373",
    "data-name": "Group 13373",
    transform: "translate(223.406 229.589)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13372",
    "data-name": "Group 13372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13371",
    "data-name": "Group 13371",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39618",
    "data-name": "Path 39618",
    d: "M380.495,471.224a25.024,25.024,0,0,1-2.172,3.814c-3.58-28.819-1.108-88.237-1.108-88.237a.179.179,0,0,1,.007.031c.245,1.845,3.5,83.232,3.273,84.392",
    transform: "translate(-376.384 -386.801)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13376",
    "data-name": "Group 13376",
    transform: "translate(203.967 332.524)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13375",
    "data-name": "Group 13375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13374",
    "data-name": "Group 13374",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39619",
    "data-name": "Path 39619",
    d: "M356.318,560.22a13.726,13.726,0,0,1-9.521,1.406l-3.164,44.466s4.55-37.261,6.64-38.549,4.846-2.168,6.045-7.323",
    transform: "translate(-343.633 -560.22)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13379",
    "data-name": "Group 13379",
    transform: "translate(202.26 414.925)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13378",
    "data-name": "Group 13378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13377",
    "data-name": "Group 13377",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39620",
    "data-name": "Path 39620",
    d: "M341.585,699.045h24.782s-12.743,8-18.981,7.821-7.821-7.47-5.8-7.821",
    transform: "translate(-340.757 -699.045)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39621",
    "data-name": "Path 39621",
    d: "M317.232,690.389c-.737,6.137-1.024,7.694-3.659,7.378a3,3,0,0,1-.973-.29c-2.068-1-3.317-4.281-2.872-7.989.441-3.674,2.4-6.552,4.62-7.068a3.007,3.007,0,0,1,1.076-.065c2.635.316,2.48,2.436,1.809,8.034",
    transform: "translate(-125.849 -277.327)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39622",
    "data-name": "Path 39622",
    d: "M315.052,690.186c-.6,5.037-.908,6.987-2.453,7.35a3.623,3.623,0,0,1-.833-.565c-1.557-1.379-2.42-4.246-2.038-7.424.376-3.137,1.859-5.695,3.671-6.7a3.658,3.658,0,0,1,.949-.371c1.464.8,1.263,3.053.7,7.707",
    transform: "translate(-125.849 -277.387)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39623",
    "data-name": "Path 39623",
    d: "M313.479,690.252c-.493,4.1-.785,6.159-1.714,6.974-1.557-1.38-2.42-4.246-2.038-7.424.377-3.137,1.859-5.695,3.671-6.7.758,1.107.542,3.31.081,7.148",
    transform: "translate(-125.849 -277.641)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39624",
    "data-name": "Path 39624",
    d: "M235.39,672.061l1.585,17.341-12.951-15.115H193.443l-10.9,11.561,3.632-18.24H234.2Z",
    transform: "translate(-74.194 -271.343)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13382",
    "data-name": "Group 13382",
    transform: "translate(107.917 394.332)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13381",
    "data-name": "Group 13381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13380",
    "data-name": "Group 13380",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39625",
    "data-name": "Path 39625",
    d: "M236.267,683.586,225.25,669.272H192.559l-10.745,13.006,5.179-17.927H233.9Z",
    transform: "translate(-181.814 -664.351)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39626",
    "data-name": "Path 39626",
    d: "M234.562,424.622c2.091,7.51,8.3,12.794,13.861,11.809.195-.035.389-.076.576-.126a65.181,65.181,0,0,0-2.175-13.067,103.565,103.565,0,0,0-5.766-14.024c-.067.01-.138.019-.206.031-5.564.985-8.381,7.871-6.29,15.377",
    transform: "translate(-95.055 -166.321)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39627",
    "data-name": "Path 39627",
    d: "M228.048,420.489a23.294,23.294,0,0,0,.316,2.426c.059.344.128.7.207,1.043a24.909,24.909,0,0,0,.978,3.314c2.351,6.343,6.9,10.443,11.045,9.524a4.788,4.788,0,0,0,.5-.137s-.155-3.377-.668-7.39c-.144-1.115-.313-2.279-.516-3.436-.076-.451-.158-.9-.248-1.339-.138-.7-.289-1.381-.454-2.041-.461-1.841-.985-3.669-1.515-5.387-1.7-5.49-3.487-9.861-3.487-9.861-.059.01-.12.02-.179.034-2.393.53-4.2,2.637-5.187,5.621a19.407,19.407,0,0,0-.792,7.627",
    transform: "translate(-92.657 -165.505)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13385",
    "data-name": "Group 13385",
    transform: "translate(135.316 247.357)",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13384",
    "data-name": "Group 13384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13383",
    "data-name": "Group 13383",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39628",
    "data-name": "Path 39628",
    d: "M228.048,424.361l11.613,4.007c-.138-.7-.289-1.381-.454-2.041-.461-1.841-.985-3.669-1.515-5.387-3.284-1.559-6.574-3.122-8.852-4.206a19.407,19.407,0,0,0-.792,7.627",
    transform: "translate(-227.973 -416.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39629",
    "data-name": "Path 39629",
    d: "M228.634,433.672c.059.344.128.7.207,1.043a24.918,24.918,0,0,0,.978,3.314l10.876,2c-.145-1.115-.313-2.278-.516-3.435l-11.544-2.918",
    transform: "translate(-228.242 -423.618)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39630",
    "data-name": "Path 39630",
    d: "M209.385,471.224a25.027,25.027,0,0,0,2.172,3.814c2.028,3.2,4.74,7.2,4.74,7.2s13.358-.117,13.709,0c.221.072,3.89-2.815,6.85-5.417a22.356,22.356,0,0,0,3.7-3.725c.823-1.638,2.667-33.476,2.667-33.476-22.059-14.845-22.806-47.02-22.806-47.02s-7.572-5.8-7.748-5.8a.181.181,0,0,0-.007.031c-.245,1.845-3.5,83.232-3.273,84.392",
    transform: "translate(-85.098 -157.211)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39631",
    "data-name": "Path 39631",
    d: "M180.574,632l11.348-13.623h33.1L237.4,634.841l-9.844-86.316-7.648-6.416H207.521l-8.846,5.71Z",
    transform: "translate(-73.392 -220.335)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39632",
    "data-name": "Path 39632",
    d: "M173.267,713.351l1.552,2.463,5.363,8.5h47.746l7.679-10.112.991-1.309-1.934-21.357-13.121-17.02H189.437l-12.3,14.393Z",
    transform: "translate(-70.423 -274.151)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39633",
    "data-name": "Path 39633",
    d: "M175.882,723.331l5.363,8.722h47.746l7.679-10.374-.943-10.667-13.121-17.457H190.5l-12.3,14.762Z",
    transform: "translate(-71.486 -281.889)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39634",
    "data-name": "Path 39634",
    d: "M179.93,724.18l4.938,8.032h43.972l7.072-9.553-.868-9.823L222.96,696.758H193.393l-11.329,13.595Z",
    transform: "translate(-73.131 -283.19)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39635",
    "data-name": "Path 39635",
    d: "M180.574,632l11.348-13.623h.689l14.911-76.269-8.846,5.71Z",
    transform: "translate(-73.392 -220.335)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39636",
    "data-name": "Path 39636",
    d: "M246.848,542.109l4.54,76.269h.575l12.377,16.462L254.5,548.524Z",
    transform: "translate(-100.329 -220.335)",
    fill: "#bfc1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39637",
    "data-name": "Path 39637",
    d: "M219.263,498.039V529.15l1.084.812a13.883,13.883,0,0,0,3.923,2.062q.465.16.94.279a13.973,13.973,0,0,0,7.028,0q.475-.119.94-.279a13.878,13.878,0,0,0,3.924-2.062l1.084-.812V498.039l-1.084-.812a13.971,13.971,0,0,0-3.924-2.062c-.309-.1-.623-.2-.94-.275a13.972,13.972,0,0,0-7.028,0c-.316.08-.63.172-.94.275a13.976,13.976,0,0,0-3.923,2.062Z",
    transform: "translate(-89.117 -200.96)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39638",
    "data-name": "Path 39638",
    d: "M227.7,495.165v36.859q.465.16.94.279a13.973,13.973,0,0,0,7.028,0q.475-.119.94-.279V495.165c-.309-.1-.623-.2-.94-.275a13.972,13.972,0,0,0-7.028,0c-.316.079-.63.172-.94.275",
    transform: "translate(-92.546 -200.96)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39639",
    "data-name": "Path 39639",
    d: "M229.283,494.889V532.3a13.972,13.972,0,0,0,7.028,0V494.889a13.972,13.972,0,0,0-7.028,0",
    transform: "translate(-93.19 -200.96)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39640",
    "data-name": "Path 39640",
    d: "M179.582,690.389c-.737,6.137-1.025,7.694-3.659,7.378a3,3,0,0,1-.973-.29c-2.068-1-3.317-4.281-2.872-7.989.441-3.674,2.4-6.552,4.62-7.068a3.007,3.007,0,0,1,1.076-.065c2.635.316,2.48,2.436,1.809,8.034",
    transform: "translate(-69.903 -277.327)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39641",
    "data-name": "Path 39641",
    d: "M177.4,690.186c-.6,5.037-.908,6.987-2.453,7.35a3.622,3.622,0,0,1-.833-.565c-1.557-1.379-2.42-4.246-2.038-7.424.376-3.137,1.859-5.695,3.671-6.7a3.658,3.658,0,0,1,.949-.371c1.464.8,1.262,3.053.7,7.707",
    transform: "translate(-69.903 -277.387)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39642",
    "data-name": "Path 39642",
    d: "M175.829,690.252c-.493,4.1-.785,6.159-1.714,6.974-1.558-1.38-2.42-4.246-2.038-7.424.377-3.137,1.859-5.695,3.671-6.7.758,1.107.542,3.31.081,7.148",
    transform: "translate(-69.902 -277.641)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13388",
    "data-name": "Group 13388",
    transform: "translate(134.299 235.389)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13387",
    "data-name": "Group 13387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13386",
    "data-name": "Group 13386",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39643",
    "data-name": "Path 39643",
    d: "M247.122,446.394l-3.4,34.4a22.358,22.358,0,0,0,3.7-3.724c.823-1.639,2.667-33.476,2.667-33.476-22.059-14.845-22.806-47.02-22.806-47.02s-7.806,26,19.846,49.822",
    transform: "translate(-226.26 -396.572)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13391",
    "data-name": "Group 13391",
    transform: "translate(124.276 229.589)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13390",
    "data-name": "Group 13390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13389",
    "data-name": "Group 13389",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39644",
    "data-name": "Path 39644",
    d: "M209.385,471.224a25.027,25.027,0,0,0,2.172,3.814c3.58-28.819,1.108-88.237,1.108-88.237a.181.181,0,0,0-.007.031c-.245,1.845-3.5,83.232-3.273,84.392",
    transform: "translate(-209.374 -386.801)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13394",
    "data-name": "Group 13394",
    transform: "translate(135.154 332.524)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13393",
    "data-name": "Group 13393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13392",
    "data-name": "Group 13392",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39645",
    "data-name": "Path 39645",
    d: "M227.7,560.22a13.726,13.726,0,0,0,9.521,1.406l3.164,44.466s-4.55-37.261-6.64-38.549-4.846-2.168-6.045-7.323",
    transform: "translate(-227.7 -560.22)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13397",
    "data-name": "Group 13397",
    transform: "translate(123.936 414.925)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13396",
    "data-name": "Group 13396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13395",
    "data-name": "Group 13395",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39646",
    "data-name": "Path 39646",
    d: "M233.583,699.045H208.8s12.743,8,18.981,7.821,7.821-7.47,5.8-7.821",
    transform: "translate(-208.801 -699.045)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39647",
    "data-name": "Path 39647",
    d: "M269.985,690.389c.737,6.137,1.024,7.694,3.659,7.378a3,3,0,0,0,.973-.29c2.068-1,3.317-4.281,2.872-7.989-.441-3.674-2.4-6.552-4.62-7.068a3.007,3.007,0,0,0-1.076-.065c-2.635.316-2.48,2.436-1.809,8.034",
    transform: "translate(-109.563 -277.327)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39648",
    "data-name": "Path 39648",
    d: "M273.658,690.186c.6,5.037.908,6.987,2.453,7.35a3.623,3.623,0,0,0,.833-.565c1.557-1.379,2.42-4.246,2.038-7.424-.376-3.137-1.859-5.695-3.671-6.7a3.658,3.658,0,0,0-.949-.371c-1.464.8-1.263,3.053-.7,7.707",
    transform: "translate(-111.056 -277.387)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39649",
    "data-name": "Path 39649",
    d: "M276.307,690.252c.493,4.1.785,6.159,1.714,6.974,1.557-1.38,2.42-4.246,2.038-7.424-.377-3.137-1.859-5.695-3.671-6.7-.758,1.107-.542,3.31-.081,7.148",
    transform: "translate(-112.133 -277.641)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39650",
    "data-name": "Path 39650",
    d: "M192.365,272.416a9.791,9.791,0,1,1,1.486-13.767,9.792,9.792,0,0,1-1.486,13.767",
    transform: "translate(-71.71 -103.641)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39651",
    "data-name": "Path 39651",
    d: "M221.441,256.516c0,13.354-7.059,24.18-15.767,24.18s-15.767-10.825-15.767-24.18,7.059-24.18,15.767-24.18,15.767,10.825,15.767,24.18",
    transform: "translate(-77.186 -94.431)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39652",
    "data-name": "Path 39652",
    d: "M304.387,327.121l-3.314,7.985-.823-.348-1.033-.433,2.223-7.738s-12.732-9.634-22.231-8.694-19.863,9.318-19.863,9.318l1.2,7.114-1.032.433-.823.348-3.3-8.422s9.49-11.644,25.264-11.689a29.509,29.509,0,0,1,23.729,12.126",
    transform: "translate(-103.803 -128.027)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39653",
    "data-name": "Path 39653",
    d: "M383.871,264.789A9.791,9.791,0,1,0,393.662,255a9.791,9.791,0,0,0-9.791,9.791",
    transform: "translate(-156.021 -103.641)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39654",
    "data-name": "Path 39654",
    d: "M350.264,256.516c0,13.354,7.059,24.18,15.767,24.18S381.8,269.87,381.8,256.516s-7.059-24.18-15.767-24.18-15.767,10.825-15.767,24.18",
    transform: "translate(-142.361 -94.431)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13400",
    "data-name": "Group 13400",
    transform: "translate(151.593 186.968)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13399",
    "data-name": "Group 13399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13398",
    "data-name": "Group 13398",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39655",
    "data-name": "Path 39655",
    d: "M304.387,327.121l-3.314,7.985-.823-.348,2.072-7.782a28.9,28.9,0,0,0-44.831-.129l2.024,7.911-.823.348-3.3-8.422s9.49-11.644,25.264-11.689a29.509,29.509,0,0,1,23.729,12.126",
    transform: "translate(-255.396 -314.994)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39656",
    "data-name": "Path 39656",
    d: "M314.231,239.121l-3.156,17.492A44.934,44.934,0,0,1,279.3,299.544l2.179-7.975-.578-.688a29.786,29.786,0,0,0-45.581,0l-.579.688,2.179,7.975a44.922,44.922,0,0,1-31.772-42.931l-3.16-17.492a9.873,9.873,0,0,1,9.717-11.623h92.811a9.869,9.869,0,0,1,9.713,11.623",
    transform: "translate(-82.032 -92.464)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13403",
    "data-name": "Group 13403",
    transform: "translate(142.692 135.033)",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13402",
    "data-name": "Group 13402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13401",
    "data-name": "Group 13401",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39657",
    "data-name": "Path 39657",
    d: "M309.228,227.5l-6.464,16.332a12.672,12.672,0,0,1-11.847,8.054H258.711a12.672,12.672,0,0,1-11.847-8.054L240.4,227.5Z",
    transform: "translate(-240.4 -227.497)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13406",
    "data-name": "Group 13406",
    transform: "translate(143.828 135.033)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13405",
    "data-name": "Group 13405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13404",
    "data-name": "Group 13404",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39658",
    "data-name": "Path 39658",
    d: "M308.87,227.5l-6.226,15.743a11.106,11.106,0,0,1-10.319,7.015H258.859a11.106,11.106,0,0,1-10.319-7.015L242.314,227.5Z",
    transform: "translate(-242.314 -227.497)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39659",
    "data-name": "Path 39659",
    d: "M308.529,227.5l-6.161,15.571a10.683,10.683,0,0,1-9.93,6.75H260.232a10.685,10.685,0,0,1-9.93-6.75L244.141,227.5Z",
    transform: "translate(-99.229 -92.464)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39660",
    "data-name": "Path 39660",
    d: "M304.485,219.082s-4.336,5.507-19.245,5.507c-14.735,0-19.188-5.507-19.188-5.507V206.076h38.433Z",
    transform: "translate(-108.134 -83.758)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39661",
    "data-name": "Path 39661",
    d: "M302.438,217.543a56.548,56.548,0,0,1-36.4,0,3.252,3.252,0,0,1-2.234-4.208,3.417,3.417,0,0,1,4.262-1.761,50.241,50.241,0,0,0,32.342,0,3.416,3.416,0,0,1,4.262,1.761,3.253,3.253,0,0,1-2.234,4.208",
    transform: "translate(-107.132 -85.914)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39662",
    "data-name": "Path 39662",
    d: "M286.123,219.684a53.676,53.676,0,0,1-17.314-2.862c-.454-.154-.587-.461-.585-.535a.63.63,0,0,1,.56-.265.876.876,0,0,1,.284.047,53,53,0,0,0,34.111,0,.886.886,0,0,1,.281-.046.615.615,0,0,1,.564.284.831.831,0,0,1-.588.516,53.667,53.667,0,0,1-17.315,2.863",
    transform: "translate(-109.017 -87.8)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39663",
    "data-name": "Path 39663",
    d: "M286.123,217.562A53.676,53.676,0,0,1,268.81,214.7c-.454-.154-.587-.461-.585-.535a.629.629,0,0,1,.56-.265.876.876,0,0,1,.284.047,53,53,0,0,0,34.111,0,.886.886,0,0,1,.281-.046.615.615,0,0,1,.564.284.831.831,0,0,1-.588.516,53.667,53.667,0,0,1-17.315,2.863",
    transform: "translate(-109.017 -86.937)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39664",
    "data-name": "Path 39664",
    d: "M302.841,230.522a68.015,68.015,0,0,1-40.012,0c-2.131-.657-3.209-2.61-2.456-4.208a3.9,3.9,0,0,1,4.686-1.761,60.43,60.43,0,0,0,35.552,0,3.9,3.9,0,0,1,4.685,1.761c.754,1.6-.326,3.55-2.455,4.208",
    transform: "translate(-105.728 -91.189)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39665",
    "data-name": "Path 39665",
    d: "M285.045,232.663a64.889,64.889,0,0,1-19.193-2.886l-.013,0a.4.4,0,0,1,.115-.772h.033a1.614,1.614,0,0,1,.472.07,63.179,63.179,0,0,0,37.176,0,1.6,1.6,0,0,1,.47-.069h.033a.4.4,0,0,1,.115.772l-.013,0a64.9,64.9,0,0,1-19.194,2.886",
    transform: "translate(-107.939 -93.075)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39666",
    "data-name": "Path 39666",
    d: "M285.045,229.159a64.89,64.89,0,0,1-19.193-2.886l-.013,0a.4.4,0,0,1,.115-.772h.033a1.614,1.614,0,0,1,.472.07,63.18,63.18,0,0,0,37.176,0,1.6,1.6,0,0,1,.47-.069h.033a.4.4,0,0,1,.115.772l-.013,0a64.9,64.9,0,0,1-19.194,2.886",
    transform: "translate(-107.939 -91.651)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39667",
    "data-name": "Path 39667",
    d: "M311.672,63.452v.007a43.545,43.545,0,0,1-84.331,0v0c.145-.193.289-.385.434-.575.193-.254.389-.509.589-.757.158-.2.316-.4.475-.589.406-.5.826-.991,1.253-1.473.172-.2.347-.4.526-.592s.354-.389.537-.582c.358-.385.722-.764,1.1-1.139.186-.186.372-.372.562-.558.172-.169.347-.337.523-.506.207-.2.413-.389.623-.582l.475-.434c.065-.055.127-.113.189-.169.127-.113.258-.227.385-.337q.361-.321.733-.63c.052-.042.1-.086.151-.128.193-.161.389-.323.585-.482.32-.261.647-.519.974-.771a52.506,52.506,0,0,1,64.1,0c.327.255.654.51.974.775.2.155.392.317.585.478l.148.128c.2.169.4.341.6.513s.4.347.6.523.393.354.585.53a52.079,52.079,0,0,1,4.01,4.116c.189.217.375.434.561.651s.369.441.551.664.344.424.513.637c.021.024.041.052.059.076.169.21.334.423.5.636.148.19.292.382.437.575",
    transform: "translate(-92.401 -17.165)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39668",
    "data-name": "Path 39668",
    d: "M228.389,201.689s17.1-12.918,37.792-12.918c20.782,0,40.262,12.918,40.262,12.918s3.164-.821,3.75-9.023S298.826,182.6,277.5,182.6s-49.915,1.4-54.016,5.384,2.309,13.709,4.9,13.709",
    transform: "translate(-90.29 -74.214)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39669",
    "data-name": "Path 39669",
    d: "M363.008,200.06a34.7,34.7,0,0,1-1.07,5.858h-1.949s1.15-12.436-6.1-9.052a6.857,6.857,0,0,1,2.368-2.919A5.509,5.509,0,0,1,359.4,193c4.04,0,3.748,4.54,3.6,7.059",
    transform: "translate(-143.837 -78.443)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39670",
    "data-name": "Path 39670",
    d: "M364.151,200.06a34.7,34.7,0,0,1-1.07,5.858H362.4c.028-3.721.968-14.322-5.693-10.722a6.462,6.462,0,0,1,.7-1.249,5.509,5.509,0,0,1,3.143-.946c4.04,0,3.748,4.54,3.6,7.059",
    transform: "translate(-144.98 -78.443)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39671",
    "data-name": "Path 39671",
    d: "M227.53,200.06a34.7,34.7,0,0,0,1.07,5.858h1.949s-1.15-12.436,6.1-9.052a6.857,6.857,0,0,0-2.368-2.919,5.509,5.509,0,0,0-3.143-.946c-4.04,0-3.748,4.54-3.6,7.059",
    transform: "translate(-92.449 -78.443)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13409",
    "data-name": "Group 13409",
    transform: "translate(135.011 114.557)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13408",
    "data-name": "Group 13408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13407",
    "data-name": "Group 13407",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39672",
    "data-name": "Path 39672",
    d: "M227.53,200.06a34.7,34.7,0,0,0,1.07,5.858h.682c-.028-3.721-.967-14.322,5.693-10.722a6.462,6.462,0,0,0-.7-1.249,5.509,5.509,0,0,0-3.143-.946c-4.04,0-3.748,4.54-3.6,7.059",
    transform: "translate(-227.46 -193)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39673",
    "data-name": "Path 39673",
    d: "M315.042,87.541V141.2a11.863,11.863,0,0,1-11.864,11.864v-8.735a3.319,3.319,0,0,0-5.541-2.472,52.49,52.49,0,0,1-70.907,0,3.319,3.319,0,0,0-5.541,2.472v8.732A11.863,11.863,0,0,1,209.324,141.2V87.537a4.253,4.253,0,0,1,4.254-4.254q.2-.5.413-.981c.09-.21.183-.416.275-.623.114-.255.227-.506.348-.757.1-.207.193-.41.293-.613.055-.12.113-.237.172-.358.1-.21.207-.417.313-.623.145-.285.293-.568.44-.85l.372-.681c.138-.255.282-.506.423-.754s.289-.5.437-.747.29-.481.437-.719.313-.5.475-.751.3-.464.451-.7c.165-.248.334-.5.5-.74s.331-.475.5-.705.337-.468.509-.7a1.176,1.176,0,0,1,.083-.11v0c.144-.193.289-.385.434-.575.192-.255.389-.51.588-.757.158-.2.317-.4.475-.589.407-.5.826-.991,1.253-1.473.172-.2.348-.4.526-.592s.355-.389.537-.582q.537-.578,1.1-1.139c.186-.186.372-.372.561-.558.172-.169.348-.337.523-.506s.369-.348.554-.52c.024-.021.045-.041.069-.062l.475-.434c.065-.055.128-.113.189-.169.128-.113.258-.227.386-.337q.361-.321.733-.63c4,11.055,17.733,18.707,33.765,18.707s29.759-7.652,33.755-18.707c.2.169.4.341.6.513s.4.347.6.523.392.354.585.53a52.071,52.071,0,0,1,4.009,4.116c.189.217.375.434.561.651s.369.441.551.664.344.424.513.637c.021.024.042.052.059.076.169.21.334.423.5.637.148.189.293.382.437.575.2.268.4.541.589.813.165.23.331.468.5.705s.337.493.5.737.306.465.454.7.32.5.475.751c.145.23.286.464.424.7q.279.465.547.94c.1.172.2.347.293.523s.2.365.3.547c.09.162.176.327.262.492.1.183.192.365.286.551.107.207.21.413.313.623q.237.48.465.97c.12.251.234.5.347.757.093.207.186.413.275.623q.212.485.413.981a4.258,4.258,0,0,1,4.258,4.258",
    transform: "translate(-85.078 -25.586)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13412",
    "data-name": "Group 13412",
    transform: "translate(144.079 25.068)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13411",
    "data-name": "Group 13411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13410",
    "data-name": "Group 13410",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39674",
    "data-name": "Path 39674",
    d: "M308.787,53.925c-4.01,10.157-17.279,17.616-33.022,17.616s-29.019-7.459-33.029-17.619c.32-.262.647-.519.974-.771a52.5,52.5,0,0,1,64.1,0c.327.255.654.509.974.775",
    transform: "translate(-242.737 -42.233)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39675",
    "data-name": "Path 39675",
    d: "M308.922,50.439c-3.413,10.763-17.093,18.811-33.45,18.811s-30.04-8.047-33.457-18.811a54.8,54.8,0,0,1,66.907,0",
    transform: "translate(-98.365 -15.869)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39676",
    "data-name": "Path 39676",
    d: "M313.229,105.818v27.391a6.343,6.343,0,0,1-6.343,6.343s-30.571-8.643-40.763-8.643c-5.631,0-17.489,2.64-26.967,5-7.675,1.911-13.792,3.642-13.792,3.642a6.343,6.343,0,0,1-6.343-6.343V105.818a6.342,6.342,0,0,1,6.343-6.34s13.826,1.855,25.983,3.066c5.917.592,11.441,1.033,14.78,1.033,10.188,0,40.759-4.1,40.759-4.1a6.342,6.342,0,0,1,6.343,6.34",
    transform: "translate(-89.019 -40.432)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13415",
    "data-name": "Group 13415",
    transform: "translate(130.001 59.046)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13414",
    "data-name": "Group 13414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13413",
    "data-name": "Group 13413",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39677",
    "data-name": "Path 39677",
    d: "M254.847,116.935c-1.163,8.147-10.216,11.992-15.691,18.976-7.676,1.91-13.792,3.641-13.792,3.641a6.343,6.343,0,0,1-6.343-6.343V105.818a6.342,6.342,0,0,1,6.343-6.34s13.826,1.855,25.983,3.066c2.289,4.041,4.24,9.214,3.5,14.391",
    transform: "translate(-219.02 -99.478)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39678",
    "data-name": "Path 39678",
    d: "M221.395,107.886v24.121a6.126,6.126,0,0,0,6.35,5.871s21.123-5.521,34.13-7.393a17.317,17.317,0,0,1,3.938.427c-10.488.169-40.449,8.639-40.449,8.639a6.343,6.343,0,0,1-6.343-6.344v-27.39a6.342,6.342,0,0,1,6.343-6.34s30.571,4.1,40.759,4.1c8.085,0,28.991-2.578,37.289-3.645-9.747,1.7-27.6,4.633-34.842,4.633-10.206,0-40.824-2.554-40.824-2.554a6.127,6.127,0,0,0-6.35,5.876",
    transform: "translate(-89.019 -40.432)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39679",
    "data-name": "Path 39679",
    d: "M396.1,140.839a18.1,18.1,0,0,1-3.7,11.138,15.665,15.665,0,0,1-4.312,3.383c-.227.134-.448.265-.658.385V125.932c.21.12.43.251.658.385A15.665,15.665,0,0,1,392.4,129.7a18.1,18.1,0,0,1,3.7,11.138",
    transform: "translate(-157.468 -51.184)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39680",
    "data-name": "Path 39680",
    d: "M392.595,121.134v32.949a.314.314,0,0,1-.06.184,19.335,19.335,0,0,1-2.6,2.888.3.3,0,0,1-.51-.222V118.287a.3.3,0,0,1,.51-.221,19.418,19.418,0,0,1,2.6,2.885.312.312,0,0,1,.061.184",
    transform: "translate(-158.279 -47.954)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39681",
    "data-name": "Path 39681",
    d: "M400.231,142.648a21.416,21.416,0,0,1-3.633,12.1.387.387,0,0,1-.7-.223V130.773a.387.387,0,0,1,.7-.223,21.416,21.416,0,0,1,3.633,12.1",
    transform: "translate(-160.907 -52.993)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13418",
    "data-name": "Group 13418",
    transform: "translate(229.965 74.748)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13417",
    "data-name": "Group 13417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13416",
    "data-name": "Group 13416",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39682",
    "data-name": "Path 39682",
    d: "M388.091,126.317V155.36c-.227.134-.448.265-.658.385V125.931c.21.12.43.252.658.386",
    transform: "translate(-387.433 -125.932)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39683",
    "data-name": "Path 39683",
    d: "M194.717,140.839a18.1,18.1,0,0,0,3.7,11.138,15.665,15.665,0,0,0,4.312,3.383c.227.134.448.265.658.385V125.932c-.21.12-.43.251-.658.385a15.665,15.665,0,0,0-4.312,3.383,18.1,18.1,0,0,0-3.7,11.138",
    transform: "translate(-79.141 -51.184)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39684",
    "data-name": "Path 39684",
    d: "M201.995,121.134v32.949a.314.314,0,0,0,.06.184,19.337,19.337,0,0,0,2.6,2.888.3.3,0,0,0,.51-.222V118.287a.3.3,0,0,0-.51-.221,19.418,19.418,0,0,0-2.6,2.885.312.312,0,0,0-.061.184",
    transform: "translate(-82.099 -47.954)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39685",
    "data-name": "Path 39685",
    d: "M193.558,142.648a21.415,21.415,0,0,0,3.633,12.1.388.388,0,0,0,.7-.223V130.773a.388.388,0,0,0-.7-.223,21.416,21.416,0,0,0-3.633,12.1",
    transform: "translate(-78.67 -52.993)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13421",
    "data-name": "Group 13421",
    transform: "translate(123.589 74.748)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13420",
    "data-name": "Group 13420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13419",
    "data-name": "Group 13419",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39686",
    "data-name": "Path 39686",
    d: "M208.217,126.317V155.36c.227.134.448.265.658.385V125.931c-.21.12-.43.252-.658.386",
    transform: "translate(-208.217 -125.932)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13424",
    "data-name": "Group 13424",
    transform: "translate(129.829 38.997)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13423",
    "data-name": "Group 13423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13422",
    "data-name": "Group 13422",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39687",
    "data-name": "Path 39687",
    d: "M241.722,84.05s-15.729,1.366-22.992-2.623c.055-.12.114-.237.172-.358.1-.21.207-.416.313-.623.144-.286.293-.568.44-.851l.372-.681c.138-.255.283-.506.424-.754s.289-.5.437-.747.289-.482.437-.719.313-.5.475-.75.3-.465.451-.7c.166-.248.334-.5.5-.74s.331-.475.5-.706.337-.468.509-.7a1.213,1.213,0,0,1,.083-.11v0c.145-.193.289-.386.434-.575.193-.255.389-.509.589-.757.158-.2.316-.4.475-.588.406-.5.826-.991,1.253-1.473.172-.2.347-.4.526-.592s.354-.389.537-.582c.359-.386.723-.765,1.1-1.14.186-.186.372-.372.561-.557.172-.169.347-.337.523-.506s.368-.347.554-.519c.093,4.86,1.652,13.909,11.33,18.349",
    transform: "translate(-218.73 -65.7)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13427",
    "data-name": "Group 13427",
    transform: "translate(131.094 95.25)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13426",
    "data-name": "Group 13426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13425",
    "data-name": "Group 13425",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39688",
    "data-name": "Path 39688",
    d: "M231.75,167.142s28.941-6.784,30.933-6.667-3.253,17.988-6.929,19.306-25.293-5.362-29.863-1.964a7.331,7.331,0,0,0-2.578,8.423s-9.341-15.037,8.436-19.1",
    transform: "translate(-220.861 -160.473)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39689",
    "data-name": "Path 39689",
    d: "M303.448,327.992l-2.225,7.737c-3.587.874-7.344.443-11.218.443H273.769c-3.871,0-7.631.432-11.214-.443l-2.226-7.737a29.128,29.128,0,0,1,43.118,0",
    transform: "translate(-105.808 -129.431)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39690",
    "data-name": "Path 39690",
    d: "M306.4,393.047a49.588,49.588,0,0,0-6.206,24.021q0,1.507.093,3.022a16.046,16.046,0,0,1-1.408,1.325,36.859,36.859,0,0,1-20.163,8.144,44.989,44.989,0,0,1-4.733.245,42.831,42.831,0,0,1-6.749-.526,39.7,39.7,0,0,1-12.79-4.33,29.763,29.763,0,0,1-6.767-4.857,49.593,49.593,0,0,0-6.112-27.043,5.518,5.518,0,0,1,1.236-6.856c3.118-2.675,8.043-6.732,13.268-10.405.22-.155.437-.306.657-.458,6.268-4.34,12.877-8.023,17.258-8.023,4.334,0,10.839,3.6,17.045,7.875l.179.123c5.48,3.8,10.708,8.1,13.964,10.894a5.508,5.508,0,0,1,1.229,6.85",
    transform: "translate(-97.901 -149.288)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13430",
    "data-name": "Group 13430",
    transform: "translate(158.166 218.017)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13429",
    "data-name": "Group 13429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13428",
    "data-name": "Group 13428",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39691",
    "data-name": "Path 39691",
    d: "M289.119,429.559a44.978,44.978,0,0,1-4.732.245,42.759,42.759,0,0,1-6.75-.527c-7.855-19.422-10.44-44.214-11.165-53.49,6.457-4.537,13.379-8.481,17.915-8.481,4.333,0,10.838,3.6,17.044,7.875-12.346,28.654-12.811,47.11-12.312,54.379",
    transform: "translate(-266.471 -367.305)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13433",
    "data-name": "Group 13433",
    transform: "translate(158.824 218.017)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13432",
    "data-name": "Group 13432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13431",
    "data-name": "Group 13431",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39692",
    "data-name": "Path 39692",
    d: "M302.06,375.3c-1.91,3.322-7.545,11.06-18.1,10.016-11.538-1.139-15.282-7.442-16.377-9.991,6.267-4.341,12.876-8.023,17.258-8.023,4.334,0,10.838,3.6,17.044,7.875.059.042.12.083.179.124",
    transform: "translate(-267.579 -367.305)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39693",
    "data-name": "Path 39693",
    d: "M263.557,343.01a15.318,15.318,0,0,1,4.277,10.921c-.059,6.972,0,10.135,0,10.135a19.575,19.575,0,0,0,14.821,6.8c9.608,0,15.116-7.557,15.116-7.557s.41-6.621.41-8.846.646-9.087,4.043-11.457l1.23-6.646L262.8,338.238Z",
    transform: "translate(-106.81 -136.712)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39694",
    "data-name": "Path 39694",
    d: "M291.476,359.131h0a7.557,7.557,0,0,1-7.558-7.557V332.768a7.558,7.558,0,1,1,15.116,0v18.806a7.557,7.557,0,0,1-7.558,7.557",
    transform: "translate(-115.396 -132.178)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39695",
    "data-name": "Path 39695",
    d: "M293.5,357.038h0a4.6,4.6,0,0,1-4.6-4.6V341a4.6,4.6,0,0,1,9.2,0V352.44a4.6,4.6,0,0,1-4.6,4.6",
    transform: "translate(-117.422 -136.726)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39696",
    "data-name": "Path 39696",
    d: "M299.767,341.726a60.7,60.7,0,0,0-34.261,0,1.449,1.449,0,0,1-1.825-1.1q-.741-3.585-1.481-7.17a1.448,1.448,0,0,1,.994-1.682,67.458,67.458,0,0,1,38.884,0,1.448,1.448,0,0,1,.994,1.682q-.74,3.585-1.48,7.17a1.45,1.45,0,0,1-1.825,1.1",
    transform: "translate(-106.556 -133.683)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13436",
    "data-name": "Group 13436",
    transform: "translate(155.614 195.228)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13435",
    "data-name": "Group 13435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13434",
    "data-name": "Group 13434",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39697",
    "data-name": "Path 39697",
    d: "M262.207,333.492a1.437,1.437,0,0,1,.987-1.077,67.465,67.465,0,0,1,38.883,0,1.434,1.434,0,0,1,.987,1.077c0-.012,0-.024.008-.036a1.448,1.448,0,0,0-.995-1.682,67.455,67.455,0,0,0-38.883,0,1.447,1.447,0,0,0-.994,1.682l.007.036",
    transform: "translate(-262.17 -328.911)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39698",
    "data-name": "Path 39698",
    d: "M299.331,360.258a56.391,56.391,0,0,0-29.47,0,1.256,1.256,0,0,1-1.57-.873q-.637-2.847-1.274-5.693a1.144,1.144,0,0,1,.855-1.336,62.667,62.667,0,0,1,33.447,0,1.143,1.143,0,0,1,.855,1.336l-1.273,5.693a1.256,1.256,0,0,1-1.57.873",
    transform: "translate(-108.516 -142.288)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13439",
    "data-name": "Group 13439",
    transform: "translate(158.476 207.795)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13438",
    "data-name": "Group 13438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13437",
    "data-name": "Group 13437",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39699",
    "data-name": "Path 39699",
    d: "M267.024,353.72a1.18,1.18,0,0,1,.849-.855,62.668,62.668,0,0,1,33.447,0,1.179,1.179,0,0,1,.849.855l.006-.028a1.144,1.144,0,0,0-.855-1.336,62.667,62.667,0,0,0-33.447,0,1.145,1.145,0,0,0-.855,1.336l.007.028",
    transform: "translate(-266.992 -350.083)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39700",
    "data-name": "Path 39700",
    d: "M299.245,376.72a58.733,58.733,0,0,0-28.514,0,1.229,1.229,0,0,1-1.519-.783l-1.232-5.1a1.026,1.026,0,0,1,.827-1.2,65.281,65.281,0,0,1,32.361,0,1.027,1.027,0,0,1,.827,1.2l-1.232,5.1a1.229,1.229,0,0,1-1.519.783",
    transform: "translate(-108.907 -149.407)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13442",
    "data-name": "Group 13442",
    transform: "translate(159.047 218.191)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13441",
    "data-name": "Group 13441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13440",
    "data-name": "Group 13440",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39701",
    "data-name": "Path 39701",
    d: "M267.986,370.858a1.1,1.1,0,0,1,.821-.767,65.265,65.265,0,0,1,32.361,0,1.1,1.1,0,0,1,.822.767l.007-.026a1.027,1.027,0,0,0-.828-1.2,65.264,65.264,0,0,0-32.361,0,1.026,1.026,0,0,0-.827,1.2l.006.026",
    transform: "translate(-267.954 -367.598)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13445",
    "data-name": "Group 13445",
    transform: "translate(135.051 182.662)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13444",
    "data-name": "Group 13444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13443",
    "data-name": "Group 13443",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39702",
    "data-name": "Path 39702",
    d: "M309.582,319.695a44.849,44.849,0,0,1-19.836,12.463l2.178-7.974-.578-.689a29.786,29.786,0,0,0-45.581,0l-.578.689,2.179,7.974a44.838,44.838,0,0,1-19.839-12.463c6.422-7,22.372-11.954,41.027-11.954s34.6,4.956,41.027,11.954",
    transform: "translate(-227.527 -307.74)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13448",
    "data-name": "Group 13448",
    transform: "translate(200.524 239.475)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13447",
    "data-name": "Group 13447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13446",
    "data-name": "Group 13446",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39703",
    "data-name": "Path 39703",
    d: "M345.806,407.74a49.588,49.588,0,0,0-6.206,24.021q0,1.507.093,3.022a16.052,16.052,0,0,1-1.408,1.325c-2.757-19.97,7.964-32.653,7.964-32.653l.007.007a5.512,5.512,0,0,1-.451,4.278",
    transform: "translate(-337.833 -403.455)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13451",
    "data-name": "Group 13451",
    transform: "translate(142.974 239.475)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13450",
    "data-name": "Group 13450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13449",
    "data-name": "Group 13449",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39704",
    "data-name": "Path 39704",
    d: "M241.565,407.74a49.588,49.588,0,0,1,6.206,24.021q0,1.507-.093,3.022a16.054,16.054,0,0,0,1.408,1.325c2.757-19.97-7.964-32.653-7.964-32.653l-.007.007a5.512,5.512,0,0,0,.451,4.278",
    transform: "translate(-240.875 -403.455)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13454",
    "data-name": "Group 13454",
    transform: "translate(201.906 289.551)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13453",
    "data-name": "Group 13453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13452",
    "data-name": "Group 13452",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39705",
    "data-name": "Path 39705",
    d: "M340.7,494.237a13.462,13.462,0,0,1,12.245-3.925,8.294,8.294,0,0,0-9.093-1.874c-5.613,2.109-3.152,5.8-3.152,5.8",
    transform: "translate(-340.162 -487.821)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13457",
    "data-name": "Group 13457",
    transform: "translate(129.317 289.551)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13456",
    "data-name": "Group 13456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13455",
    "data-name": "Group 13455",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39706",
    "data-name": "Path 39706",
    d: "M218.4,494.237a13.462,13.462,0,0,1,12.245-3.925,8.294,8.294,0,0,0-9.093-1.874c-5.612,2.109-3.152,5.8-3.152,5.8",
    transform: "translate(-217.867 -487.821)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13460",
    "data-name": "Group 13460",
    transform: "translate(126.546 163.062)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13459",
    "data-name": "Group 13459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13458",
    "data-name": "Group 13458",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39707",
    "data-name": "Path 39707",
    d: "M213.2,274.73s1,19.3,8.505,22.752,17.039-8.436,21.4-8.348-3.72-3.779-11.015-1.23S214.6,274.211,213.2,274.73",
    transform: "translate(-213.198 -274.718)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39708",
    "data-name": "Path 39708",
    d: "M290.671,313.3a2.11,2.11,0,0,1-.829-.366,38.1,38.1,0,0,1-5.375-4.51,3.9,3.9,0,0,1-.545-.726c-1.412-1.475,2.484-5.535,4.826-5.537.182,0,.726.562,1.139.863a37.283,37.283,0,0,1,4.686,4.788,3.744,3.744,0,0,1,.491.654c.049.284-4,4.837-4.393,4.835",
    transform: "translate(-115.275 -122.812)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13463",
    "data-name": "Group 13463",
    transform: "translate(168.646 179.93)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13462",
    "data-name": "Group 13462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13461",
    "data-name": "Group 13461",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39709",
    "data-name": "Path 39709",
    d: "M290.093,303.423c-.709,1.307-3.929,4.207-5.419,5.4-.387-.4-.565-.65-.545-.725.611-2.333,4.08-5.061,5.143-4.957a1.25,1.25,0,0,1,.822.283",
    transform: "translate(-284.126 -303.137)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13466",
    "data-name": "Group 13466",
    transform: "translate(174.567 185.003)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13465",
    "data-name": "Group 13465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13464",
    "data-name": "Group 13464",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39710",
    "data-name": "Path 39710",
    d: "M294.931,317.173a2.11,2.11,0,0,1-.829-.366,17.755,17.755,0,0,0,4.731-5.122,3.74,3.74,0,0,1,.491.654c.049.284-4,4.837-4.393,4.835",
    transform: "translate(-294.102 -311.684)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39711",
    "data-name": "Path 39711",
    d: "M280,326.121a2.327,2.327,0,0,1-.979-.172,41.878,41.878,0,0,1-6.912-3.4,4.262,4.262,0,0,1-.772-.63c-1.893-1.2,1.192-6.551,3.688-7.168a7.169,7.169,0,0,1,1.441.621,40.853,40.853,0,0,1,6.251,3.87,4.069,4.069,0,0,1,.7.569c.127.29-2.987,6.2-3.411,6.306",
    transform: "translate(-110.044 -127.928)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13469",
    "data-name": "Group 13469",
    transform: "translate(161.293 187.314)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13468",
    "data-name": "Group 13468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13467",
    "data-name": "Group 13467",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39712",
    "data-name": "Path 39712",
    d: "M276.867,315.712c-.413,1.579-3.082,5.515-4.357,7.177-.518-.325-.773-.544-.772-.629.039-2.647,3.018-6.466,4.179-6.634a1.371,1.371,0,0,1,.95.086",
    transform: "translate(-271.739 -315.578)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13472",
    "data-name": "Group 13472",
    transform: "translate(168.978 191.319)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13471",
    "data-name": "Group 13471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13470",
    "data-name": "Group 13470",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39713",
    "data-name": "Path 39713",
    d: "M285.664,329.2a2.327,2.327,0,0,1-.979-.172c1.8-1.793,3.1-5,3.7-6.7a4.066,4.066,0,0,1,.7.569c.127.29-2.987,6.2-3.411,6.306",
    transform: "translate(-284.685 -322.324)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39714",
    "data-name": "Path 39714",
    d: "M278.536,346.878a2.324,2.324,0,0,1-.992.068,41.831,41.831,0,0,1-7.525-1.638,4.285,4.285,0,0,1-.9-.426c-2.126-.712-.414-6.647,1.86-7.844a7.147,7.147,0,0,1,1.547.256,40.888,40.888,0,0,1,7,2.258,4.069,4.069,0,0,1,.811.385c.193.25-1.411,6.739-1.8,6.94",
    transform: "translate(-108.987 -136.978)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13475",
    "data-name": "Group 13475",
    transform: "translate(160.022 200.293)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13474",
    "data-name": "Group 13474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13473",
    "data-name": "Group 13473",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39715",
    "data-name": "Path 39715",
    d: "M273.114,337.468c-.022,1.632-1.669,6.093-2.507,8.013-.581-.191-.881-.343-.9-.426-.6-2.578,1.379-7,2.465-7.443a1.375,1.375,0,0,1,.943-.144",
    transform: "translate(-269.597 -337.444)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13478",
    "data-name": "Group 13478",
    transform: "translate(168.557 202.575)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13477",
    "data-name": "Group 13477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13476",
    "data-name": "Group 13476",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39716",
    "data-name": "Path 39716",
    d: "M284.969,348.613a2.323,2.323,0,0,1-.992.068c1.317-2.172,1.807-5.6,1.98-7.393a4.067,4.067,0,0,1,.811.385c.193.25-1.412,6.739-1.8,6.94",
    transform: "translate(-283.977 -341.288)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39717",
    "data-name": "Path 39717",
    d: "M291.556,362.51a2.318,2.318,0,0,1-.778.619,41.862,41.862,0,0,1-7.126,2.92,4.3,4.3,0,0,1-.983.16c-2.155.619-4.112-5.239-2.918-7.515.093-.177.916-.418,1.42-.667a40.945,40.945,0,0,1,7.043-2.11,4.054,4.054,0,0,1,.886-.143c.3.1,2.66,6.351,2.456,6.736",
    transform: "translate(-113.555 -144.599)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13481",
    "data-name": "Group 13481",
    transform: "translate(166.714 213.429)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13480",
    "data-name": "Group 13480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13479",
    "data-name": "Group 13479",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39718",
    "data-name": "Path 39718",
    d: "M281.773,359.574c.908,1.356,2.082,5.965,2.481,8.021-.586.172-.921.217-.984.16-1.955-1.785-2.835-6.547-2.192-7.527a1.376,1.376,0,0,1,.694-.654",
    transform: "translate(-280.871 -359.574)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13484",
    "data-name": "Group 13484",
    transform: "translate(174.659 211.171)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13483",
    "data-name": "Group 13483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13482",
    "data-name": "Group 13482",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39719",
    "data-name": "Path 39719",
    d: "M297.6,362.51a2.318,2.318,0,0,1-.778.619c-.148-2.536-1.689-5.638-2.564-7.212a4.054,4.054,0,0,1,.886-.143c.3.1,2.66,6.351,2.456,6.736",
    transform: "translate(-294.257 -355.771)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39720",
    "data-name": "Path 39720",
    d: "M323.255,292.583s-.009-7.606-.4-9.857,1.992-14.673,3.053-15.593,4.946-.776,5.065,2.719-1.359,9.5-.975,11,.677,13.877-.475,14.2-6.254-.82-6.266-2.464",
    transform: "translate(-131.202 -108.378)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39721",
    "data-name": "Path 39721",
    d: "M329.61,294.792c-1.276.016-4.268-.875-4.629-1.553,0-.684-.025-7.738-.418-9.984-.215-1.23.342-6.061,1.207-9.508A31.454,31.454,0,0,1,327.3,268.6a2.447,2.447,0,0,1,1.629-.137,2.054,2.054,0,0,1,1.7,2.132c.119,3.474-1.238,10.067-.943,11.219.388,1.514.487,10.943-.08,12.978",
    transform: "translate(-131.897 -109.085)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39722",
    "data-name": "Path 39722",
    d: "M329.816,291.085c.024.095.05.2.072.318.454,2.206.571,7.774-.061,8.582-.182.234-2.031-.941-4.088-1.216-2.206-.294-3.383,1-4.272.5-1.146-.644-1.636-4.82-1.266-7.13a2.461,2.461,0,0,1,.551-1.414c1.148-.978,8.553-1.57,9.064.362",
    transform: "translate(-130.093 -117.791)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39723",
    "data-name": "Path 39723",
    d: "M330.6,275.835c-.841.782-8.014-.944-8.231-1.279a1.613,1.613,0,0,1-.094-.921c0-.018,0-.038.006-.059a33.979,33.979,0,0,1,1.685-6.261c1.689-3.072,7.39-2.831,7.717.014a63.456,63.456,0,0,1-.8,7.186c-.036.207-.067.394-.1.56a3.049,3.049,0,0,1-.188.759",
    transform: "translate(-130.981 -107.749)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13487",
    "data-name": "Group 13487",
    transform: "translate(190.107 172.02)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13486",
    "data-name": "Group 13486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13485",
    "data-name": "Group 13485",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39724",
    "data-name": "Path 39724",
    d: "M329.9,291.085c.024.095.05.2.072.318-2.334.1-6.206-.133-9.687.734a2.461,2.461,0,0,1,.551-1.414c1.148-.978,8.553-1.57,9.064.362",
    transform: "translate(-320.283 -289.811)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13490",
    "data-name": "Group 13490",
    transform: "translate(191.282 165.887)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13489",
    "data-name": "Group 13489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13488",
    "data-name": "Group 13488",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39725",
    "data-name": "Path 39725",
    d: "M330.6,281.677c-.841.782-8.014-.944-8.231-1.279a1.613,1.613,0,0,1-.094-.921,34.652,34.652,0,0,0,8.513,1.441,3.049,3.049,0,0,1-.188.759",
    transform: "translate(-322.263 -279.478)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39726",
    "data-name": "Path 39726",
    d: "M371.614,364.272l7.364-23.589s-6.051-1.878-9.722-3.025c-1.543-.482-2.666-.835-2.738-.865l-9.949,22.289,5.854,2.022Z",
    transform: "translate(-144.924 -136.886)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39727",
    "data-name": "Path 39727",
    d: "M310.011,342.8s-11.64,3.479-22.451-1.789c-8.592-4.187-8.89-11.1-9.03-12.446a30.1,30.1,0,0,1,2.2-12.9s2.048-6.254,9.794-9.292c0,0,10.464-3.589,15.292-1.132s5.141,4.179,6.136,3.667,2.989.074,4.732,3.485a48.8,48.8,0,0,0,3.224,5.5Z",
    transform: "translate(-113.185 -123.716)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13493",
    "data-name": "Group 13493",
    transform: "translate(211.646 199.907)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13492",
    "data-name": "Group 13492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13491",
    "data-name": "Group 13491",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39728",
    "data-name": "Path 39728",
    d: "M362.424,361.1a22.3,22.3,0,0,0,6.833-23.445c-1.543-.481-2.666-.835-2.738-.865l-9.949,22.289Z",
    transform: "translate(-356.57 -336.793)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39729",
    "data-name": "Path 39729",
    d: "M395.3,363.669c2.87-2.454,4.694-6.023,2.87-11.058-2.1-5.79-7.413-9.454-12.684-11.8a59.886,59.886,0,0,0-9.893-3.268.631.631,0,0,0-.766.75c3.007,13.723-4.737,21.319-7.548,23.563a.632.632,0,0,0,.2,1.1c8.372,2.729,16.147,5.249,16.616,5.345a22.32,22.32,0,0,0,11.206-4.631",
    transform: "translate(-149.179 -137.185)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13496",
    "data-name": "Group 13496",
    transform: "translate(236.304 203.63)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13495",
    "data-name": "Group 13495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13494",
    "data-name": "Group 13494",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39730",
    "data-name": "Path 39730",
    d: "M407.928,365.92c2.87-2.454,4.694-6.023,2.87-11.058-2.1-5.79-7.413-9.454-12.684-11.8,0,0,16.132,12.247,10.19,22.192-.134.224-.258.444-.376.663",
    transform: "translate(-398.114 -343.066)",
    fill: "#a7a7a7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39731",
    "data-name": "Path 39731",
    d: "M321.3,324.028s-13.184-9.743-16.85-11.4-12.2,7.213-13.072,10.034,3.05,15.392,4.05,16.519,16.5,2.137,18.163,1.536,9.625-15.286,7.709-16.688",
    transform: "translate(-118.377 -126.981)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39732",
    "data-name": "Path 39732",
    d: "M356.987,333.039a1.531,1.531,0,0,0-.861-.966c-3.23-1.387-14.226-6.112-17.451-5.277a7.74,7.74,0,0,0-1.947.842,19,19,0,0,0-8.123,11.452c-1.114,4.7.758,12.148,1.994,12.554l1.165.38c2.632.864,9.358,3.068,16.331,5.346a1.545,1.545,0,0,0,1.46-.28,22.311,22.311,0,0,0,7.433-24.053",
    transform: "translate(-133.42 -132.783)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39733",
    "data-name": "Path 39733",
    d: "M313.257,50.172H218.866A47.273,47.273,0,0,1,245.5,7.673a46.18,46.18,0,0,1,10.2-3.561,47.288,47.288,0,0,1,20.723,0,46.065,46.065,0,0,1,10,3.465,47.173,47.173,0,0,1,26.835,42.594",
    transform: "translate(-88.956 -1.204)",
    fill: "#ed9023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39734",
    "data-name": "Path 39734",
    d: "M301.64,4.113l-1.346,24.994a9.026,9.026,0,0,1-18.026,0L280.917,4.113a47.312,47.312,0,0,1,20.723,0",
    transform: "translate(-114.176 -1.205)",
    fill: "#b0601b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39735",
    "data-name": "Path 39735",
    d: "M292.6,34.543h0a7.124,7.124,0,0,1-7.114-6.741L284.151,3.108S285.951,0,292.595,0c5.861,0,8.446,3.108,8.446,3.108L299.71,27.8a7.124,7.124,0,0,1-7.114,6.741",
    transform: "translate(-115.49)",
    fill: "#ed9023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39736",
    "data-name": "Path 39736",
    d: "M264.07,38.964a6.719,6.719,0,0,1-4.183,3.555,6.621,6.621,0,0,1-1.859.267,6.724,6.724,0,0,1-5.795-3.338L241.278,20.552A47,47,0,0,1,254.607,10.9l9.577,22.577a6.7,6.7,0,0,1-.114,5.489",
    transform: "translate(-98.065 -4.429)",
    fill: "#b0601b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39737",
    "data-name": "Path 39737",
    d: "M260.086,41.23h0a4.788,4.788,0,0,1-5.474-2.2l-11.525-19.87s-.478-2.81,3.749-5.2c4.039-2.279,6.8-1.665,6.8-1.665l9.53,22.458a4.789,4.789,0,0,1-3.076,6.47",
    transform: "translate(-98.794 -4.969)",
    fill: "#ed9023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39738",
    "data-name": "Path 39738",
    d: "M339.113,20.335l-11.05,19.047a6.714,6.714,0,0,1-5.788,3.338,6.6,6.6,0,0,1-1.86-.267,6.689,6.689,0,0,1-4.3-9.044l9.615-22.672a46.823,46.823,0,0,1,13.379,9.6",
    transform: "translate(-128.267 -4.364)",
    fill: "#b0601b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39739",
    "data-name": "Path 39739",
    d: "M322.245,41.23h0a4.788,4.788,0,0,0,5.474-2.2l11.525-19.87s.478-2.81-3.749-5.2c-4.039-2.279-6.8-1.665-6.8-1.665l-9.53,22.458a4.789,4.789,0,0,0,3.076,6.47",
    transform: "translate(-129.567 -4.969)",
    fill: "#ed9023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39740",
    "data-name": "Path 39740",
    d: "M314.249,90.192s-12.6,11.479-50.343,11.478-50.341-11.478-50.341-11.478V86.231c0-2.063,1.939-3.736,4.33-3.736h92.024c2.391,0,4.33,1.673,4.33,3.736Z",
    transform: "translate(-86.801 -33.529)",
    fill: "#ed9023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39741",
    "data-name": "Path 39741",
    d: "M263.906,103.074c-37.743,0-50.34-11.479-50.34-11.479v2.3s12.6,11.478,50.34,11.479S314.25,93.891,314.25,93.891V91.6s-12.6,11.479-50.343,11.479",
    transform: "translate(-86.802 -37.228)",
    fill: "#faa74d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39742",
    "data-name": "Path 39742",
    d: "M313.257,74.3H218.866a47.4,47.4,0,0,1,1.529-11.97l.007-.007s8.784,8.41,46.32,8.41,45.4-6.207,45.4-6.207.038-.032.1-.083a47.135,47.135,0,0,1,1.035,9.857",
    transform: "translate(-88.956 -25.329)",
    fill: "#b0601b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39743",
    "data-name": "Path 39743",
    d: "M112.059,467.384s-2.484,4.811-3.389,5.287-6.822-.168-6.936-.358a54.6,54.6,0,0,1,5.388-6.049,38.125,38.125,0,0,1,4.937,1.119",
    transform: "translate(-41.348 -189.504)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39744",
    "data-name": "Path 39744",
    d: "M108.15,472.591a36.805,36.805,0,0,1-3.925-.273c1.192-1.418,3.469-3.939,4.195-4.619.566.084,1.995.43,3.419.808a21.846,21.846,0,0,1-2.545,4,5.012,5.012,0,0,1-1.144.08",
    transform: "translate(-42.361 -190.092)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39745",
    "data-name": "Path 39745",
    d: "M132.249,467.846s-1.285,6.1-2.144,6.907-7.625,1.9-7.809,1.725,3.751-8.089,4.13-8.364,5.823-.268,5.823-.268",
    transform: "translate(-49.703 -190.151)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39746",
    "data-name": "Path 39746",
    d: "M129.205,475.146a42.517,42.517,0,0,1-4.44.9c.89-1.939,2.645-5.435,3.243-6.412.654-.08,2.346-.134,4.043-.15a25.137,25.137,0,0,1-1.6,5.224,5.771,5.771,0,0,1-1.246.439",
    transform: "translate(-50.71 -190.817)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39747",
    "data-name": "Path 39747",
    d: "M148.379,457.026s1.118,6.134.627,7.2-6.339,4.644-6.577,4.551.413-8.907.659-9.305,5.29-2.451,5.29-2.451",
    transform: "translate(-57.868 -185.754)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39748",
    "data-name": "Path 39748",
    d: "M147.817,465.628a42.6,42.6,0,0,1-3.771,2.511c.091-2.131.394-6.031.577-7.162.575-.322,2.121-1.011,3.686-1.667a25.137,25.137,0,0,1,.5,5.441,5.755,5.755,0,0,1-.987.878",
    transform: "translate(-58.546 -186.682)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31736",
    "data-name": "Rectangle 31736",
    width: 7.368,
    height: 22.785,
    transform: "translate(93.369 270.673)",
    fill: "#282f65"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31737",
    "data-name": "Rectangle 31737",
    width: 7.368,
    height: 22.785,
    transform: "translate(46.054 270.673)",
    fill: "#282f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39749",
    "data-name": "Path 39749",
    d: "M13.1,582.817H98.941V523.479H10.128v56.364a2.973,2.973,0,0,0,2.973,2.973",
    transform: "translate(-4.116 -212.763)",
    fill: "#282f65"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31738",
    "data-name": "Rectangle 31738",
    width: 45.505,
    height: 8.726,
    transform: "translate(24.821 361.328)",
    fill: "#1b234f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39750",
    "data-name": "Path 39750",
    d: "M159.755,582.817H210.56a2.974,2.974,0,0,0,2.974-2.973V523.479H159.755Z",
    transform: "translate(-64.931 -212.763)",
    fill: "#1b234f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31739",
    "data-name": "Rectangle 31739",
    width: 31.672,
    height: 8.726,
    transform: "translate(107.073 361.328)",
    fill: "#141a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39751",
    "data-name": "Path 39751",
    d: "M176.217,579.544H210.7V547.872H174.892V578.22a1.324,1.324,0,0,0,1.325,1.324",
    transform: "translate(-71.083 -222.677)",
    fill: "#272f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39752",
    "data-name": "Path 39752",
    d: "M182.08,576.06H216.2V544.388H180.391v29.984a1.689,1.689,0,0,0,1.689,1.689",
    transform: "translate(-73.318 -221.261)",
    fill: "#343c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39753",
    "data-name": "Path 39753",
    d: "M155.181,514.252h59.9a3.6,3.6,0,0,0,3.6-3.6V497.09a8.241,8.241,0,0,0-8.242-8.241H155.181Z",
    transform: "translate(-63.072 -198.688)",
    fill: "#943620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39754",
    "data-name": "Path 39754",
    d: "M3.6,514.252H92.109v-25.4H8.241A8.241,8.241,0,0,0,0,497.09v13.558a3.6,3.6,0,0,0,3.6,3.6",
    transform: "translate(0 -198.688)",
    fill: "#c75231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39755",
    "data-name": "Path 39755",
    d: "M119.715,534.758V518.5a.524.524,0,0,0-.524-.524H100.33a.524.524,0,0,0-.524.524v16.255a.738.738,0,0,0,.738.739h18.432a.739.739,0,0,0,.738-.739",
    transform: "translate(-40.565 -210.528)",
    fill: "#282f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39756",
    "data-name": "Path 39756",
    d: "M102.362,521.861v10.671a2.486,2.486,0,0,0,2.491,2.483h11.894a2.484,2.484,0,0,0,2.491-2.483V521.861a1.329,1.329,0,0,0-1.329-1.322H103.691a1.146,1.146,0,0,0-.425.076,1.305,1.305,0,0,0-.9,1.246",
    transform: "translate(-41.604 -211.568)",
    fill: "#b2b2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39757",
    "data-name": "Path 39757",
    d: "M44.248,534.514V518.5a.523.523,0,0,0-.524-.524H24.863a.523.523,0,0,0-.524.524v16.01a.983.983,0,0,0,.982.983H43.265a.983.983,0,0,0,.982-.983",
    transform: "translate(-9.892 -210.528)",
    fill: "#282f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39758",
    "data-name": "Path 39758",
    d: "M26.893,521.861V531.2a3.817,3.817,0,0,0,3.82,3.812h9.243a3.832,3.832,0,0,0,3.813-3.812v-9.342a1.324,1.324,0,0,0-1.329-1.322H28.222a1.146,1.146,0,0,0-.425.076,1.305,1.305,0,0,0-.9,1.246",
    transform: "translate(-10.93 -211.568)",
    fill: "#b2b2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39759",
    "data-name": "Path 39759",
    d: "M103.718,521.109V531.78a2.479,2.479,0,0,0,2.483,2.483H118.1a1.43,1.43,0,0,0,1.694-1.731V521.861a1.329,1.329,0,0,0-1.33-1.322H104.242a1.151,1.151,0,0,0-.426.076,1.2,1.2,0,0,0-.1.494",
    transform: "translate(-42.155 -211.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39760",
    "data-name": "Path 39760",
    d: "M28.249,521.109v9.342a3.81,3.81,0,0,0,3.812,3.813H41.3a3.723,3.723,0,0,0,2.18-.691,3.752,3.752,0,0,0,.836-2.37v-9.341a1.325,1.325,0,0,0-1.33-1.322H28.773a1.151,1.151,0,0,0-.426.076,1.2,1.2,0,0,0-.1.494",
    transform: "translate(-11.482 -211.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39761",
    "data-name": "Path 39761",
    d: "M76.3,459.167h55.136a1.325,1.325,0,0,0,1.325-1.325v-9.049a1.325,1.325,0,0,0-1.325-1.325H76.3a1.325,1.325,0,0,0-1.325,1.325v9.049a1.325,1.325,0,0,0,1.325,1.325",
    transform: "translate(-30.474 -181.869)",
    fill: "#1b234f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39762",
    "data-name": "Path 39762",
    d: "M178.156,544.387l-3.264,2.069h3.264Z",
    transform: "translate(-71.083 -221.261)",
    fill: "#272f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39763",
    "data-name": "Path 39763",
    d: "M238.486,597.748l-3.264,2.069v-2.069Z",
    transform: "translate(-95.604 -242.949)",
    fill: "#272f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39764",
    "data-name": "Path 39764",
    d: "M134.407,459.6a2.107,2.107,0,0,0,.007.906,38.116,38.116,0,0,0,2.007,6.723,3.882,3.882,0,0,0,.449.789c.794,1.882,6.067-.082,7-2.231a6.52,6.52,0,0,0-.34-1.388,37.224,37.224,0,0,0-2.534-6.2,3.716,3.716,0,0,0-.406-.71c-.24-.158-6.025,1.748-6.181,2.113",
    transform: "translate(-54.61 -185.937)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13499",
    "data-name": "Group 13499",
    transform: "translate(81.81 278.46)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13498",
    "data-name": "Group 13498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13497",
    "data-name": "Group 13497",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39765",
    "data-name": "Path 39765",
    d: "M144.937,469.136c-1.481.132-5.42,1.937-7.107,2.831.214.514.373.777.449.789,2.384.364,6.264-1.736,6.591-2.754a1.25,1.25,0,0,0,.066-.866",
    transform: "translate(-137.83 -469.136)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13502",
    "data-name": "Group 13502",
    transform: "translate(79.752 271.54)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13501",
    "data-name": "Group 13501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13500",
    "data-name": "Group 13500",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39766",
    "data-name": "Path 39766",
    d: "M134.407,459.6a2.107,2.107,0,0,0,.007.906,17.771,17.771,0,0,1,6.58-2.309,3.716,3.716,0,0,0-.406-.71c-.24-.158-6.025,1.748-6.181,2.113",
    transform: "translate(-134.363 -457.477)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39767",
    "data-name": "Path 39767",
    d: "M118.692,463.843a2.315,2.315,0,0,0-.231.967,41.838,41.838,0,0,0,.373,7.693,4.305,4.305,0,0,0,.271.958c.351,2.215,6.487,1.506,8.043-.539a7.141,7.141,0,0,0,0-1.569,40.94,40.94,0,0,0-1.071-7.274,4.059,4.059,0,0,0-.246-.864c-.215-.232-6.879.28-7.142.628",
    transform: "translate(-48.123 -188.246)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13505",
    "data-name": "Group 13505",
    transform: "translate(70.711 283.064)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13504",
    "data-name": "Group 13504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13503",
    "data-name": "Group 13503",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39768",
    "data-name": "Path 39768",
    d: "M127.447,476.936c-1.613-.248-6.285.64-8.317,1.15.093.6.193.926.271.958,2.445,1.015,7.132-.2,7.748-1.2a1.371,1.371,0,0,0,.3-.906",
    transform: "translate(-119.13 -476.893)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13508",
    "data-name": "Group 13508",
    transform: "translate(70.338 274.911)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13507",
    "data-name": "Group 13507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13506",
    "data-name": "Group 13506",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39769",
    "data-name": "Path 39769",
    d: "M118.733,463.843a2.315,2.315,0,0,0-.231.967c2.36-.94,5.822-.858,7.619-.731a4.059,4.059,0,0,0-.246-.864c-.215-.232-6.879.28-7.142.628",
    transform: "translate(-118.502 -463.157)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39770",
    "data-name": "Path 39770",
    d: "M99.176,457.085a2.318,2.318,0,0,0-.456.883,41.91,41.91,0,0,0-1.483,7.557,4.32,4.32,0,0,0,.033,1c-.19,2.234,5.936,3.018,7.938,1.406a7.173,7.173,0,0,0,.379-1.522,40.946,40.946,0,0,0,.705-7.319,4.073,4.073,0,0,0-.031-.9c-.154-.276-6.746-1.379-7.084-1.1",
    transform: "translate(-39.514 -185.76)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13511",
    "data-name": "Group 13511",
    transform: "translate(57.691 279.765)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13510",
    "data-name": "Group 13510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13509",
    "data-name": "Group 13509",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39771",
    "data-name": "Path 39771",
    d: "M105.576,472.214c-1.506-.628-6.256-.886-8.35-.88-.055.609-.034.946.034,1,2.13,1.572,6.973,1.513,7.81.692a1.376,1.376,0,0,0,.506-.808",
    transform: "translate(-97.194 -471.335)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13514",
    "data-name": "Group 13514",
    transform: "translate(59.206 271.281)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13513",
    "data-name": "Group 13513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13512",
    "data-name": "Group 13512",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39772",
    "data-name": "Path 39772",
    d: "M100.2,457.085a2.318,2.318,0,0,0-.456.883c2.517-.347,5.858.564,7.572,1.118a4.074,4.074,0,0,0-.031-.9c-.154-.276-6.746-1.379-7.084-1.1",
    transform: "translate(-99.747 -457.041)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39773",
    "data-name": "Path 39773",
    d: "M88.857,438.687a2.313,2.313,0,0,0-.877.468,41.844,41.844,0,0,0-5.509,5.382,4.286,4.286,0,0,0-.537.839c-1.424,1.731,3.176,5.853,5.739,5.661.2-.015.748-.674,1.175-1.039a40.911,40.911,0,0,0,4.733-5.627,4.063,4.063,0,0,0,.483-.757c.03-.315-4.773-4.963-5.207-4.928",
    transform: "translate(-33.193 -178.3)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13517",
    "data-name": "Group 13517",
    transform: "translate(48.739 266.238)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13516",
    "data-name": "Group 13516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13515",
    "data-name": "Group 13515",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39774",
    "data-name": "Path 39774",
    d: "M89.03,454c-.884-1.372-4.649-4.278-6.378-5.461-.391.47-.564.759-.537.839.862,2.5,4.884,5.2,6.039,5A1.375,1.375,0,0,0,89.03,454",
    transform: "translate(-82.113 -448.544)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13520",
    "data-name": "Group 13520",
    transform: "translate(54.788 260.387)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13519",
    "data-name": "Group 13519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13518",
    "data-name": "Group 13518",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39775",
    "data-name": "Path 39775",
    d: "M93.181,438.687a2.313,2.313,0,0,0-.877.468c2.269,1.143,4.5,3.788,5.6,5.216a4.063,4.063,0,0,0,.483-.757c.03-.315-4.773-4.963-5.207-4.928",
    transform: "translate(-92.304 -438.687)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39776",
    "data-name": "Path 39776",
    d: "M149.6,433.835s6.978,3.027,8.887,4.283,14.258,4,15.524,3.387,2.676-4.231-.486-5.728-9.257-2.523-10.481-3.471-12.469-6.13-13.219-5.2-1.73,6.065-.226,6.729",
    transform: "translate(-60.484 -173.548)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39777",
    "data-name": "Path 39777",
    d: "M151.17,428.761c-.521,1.165-.89,4.264-.411,4.865.627.272,7.092,3.094,9,4.347,1.043.686,5.7,2.092,9.206,2.666a31.38,31.38,0,0,0,5.334.636,2.447,2.447,0,0,0,.772-1.441,2.053,2.053,0,0,0-1.281-2.407c-3.141-1.488-9.732-2.86-10.672-3.588-1.236-.957-9.851-4.791-11.944-5.078",
    transform: "translate(-61.184 -174.266)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39778",
    "data-name": "Path 39778",
    d: "M164.727,431.515c-.078-.06-.164-.126-.263-.192-1.845-1.291-6.91-3.609-7.9-3.351-.287.074.058,2.238-.507,4.236-.6,2.141-2.257,2.709-2.153,3.723.136,1.308,3.774,3.415,6.042,3.992a2.463,2.463,0,0,0,1.517.056c1.353-.665,4.836-7.228,3.266-8.464",
    transform: "translate(-62.55 -173.937)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39779",
    "data-name": "Path 39779",
    d: "M178.679,437.587c-1.052.462-2.314,7.73-2.093,8.063a1.614,1.614,0,0,0,.807.452c.017.007.037.01.056.018a33.956,33.956,0,0,0,6.415.938c3.49-.33,5.532-5.659,3.05-7.089a63.525,63.525,0,0,0-6.912-2.12c-.2-.049-.389-.1-.553-.133a3.05,3.05,0,0,0-.771-.129",
    transform: "translate(-71.761 -177.851)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13523",
    "data-name": "Group 13523",
    transform: "translate(97.394 257.386)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13522",
    "data-name": "Group 13522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13521",
    "data-name": "Group 13521",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39780",
    "data-name": "Path 39780",
    d: "M168.867,433.823c-.078-.06-.164-.126-.263-.192-1.017,2.1-2.342,5.749-4.519,8.6a2.463,2.463,0,0,0,1.517.056c1.353-.665,4.836-7.228,3.266-8.464",
    transform: "translate(-164.085 -433.631)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13526",
    "data-name": "Group 13526",
    transform: "translate(104.799 259.73)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13525",
    "data-name": "Group 13525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13524",
    "data-name": "Group 13524",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39781",
    "data-name": "Path 39781",
    d: "M178.679,437.587c-1.052.462-2.314,7.73-2.093,8.063a1.614,1.614,0,0,0,.807.452,34.647,34.647,0,0,1,2.057-8.385,3.05,3.05,0,0,0-.771-.129",
    transform: "translate(-176.56 -437.581)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39782",
    "data-name": "Path 39782",
    d: "M110.86,357.062l24.575,2.6s-.678,6.3-1.083,10.124c-.17,1.608-.292,2.779-.293,2.857l-24.407.284.468-6.175Z",
    transform: "translate(-44.567 -145.124)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39783",
    "data-name": "Path 39783",
    d: "M99.551,408.792s-7.813,9.3-7.269,21.316c.433,9.548,6.657,12.564,7.839,13.23a30.129,30.129,0,0,0,12.709,3.1s6.554.6,12.416-5.3c0,0,7.447-8.18,7.109-13.587s-1.794-6.377-.93-7.088,1.118-2.773-1.321-5.726a48.749,48.749,0,0,1-3.77-5.143Z",
    transform: "translate(-37.496 -166.15)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13529",
    "data-name": "Group 13529",
    transform: "translate(65.086 219.316)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13528",
    "data-name": "Group 13528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13527",
    "data-name": "Group 13527",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39784",
    "data-name": "Path 39784",
    d: "M110.122,371.808a22.3,22.3,0,0,1,24.231,3.034c-.17,1.608-.292,2.778-.292,2.857l-24.407.284Z",
    transform: "translate(-109.653 -369.492)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39785",
    "data-name": "Path 39785",
    d: "M118.959,326.825c3.392-1.66,7.392-1.918,11.289,1.755,4.481,4.223,5.735,10.556,5.793,16.325a59.877,59.877,0,0,1-.928,10.377.631.631,0,0,1-.993.405c-11.4-8.207-21.448-4.114-24.623-2.425a.632.632,0,0,1-.926-.618c.819-8.767,1.69-15.52,1.69-16,0-3.7,3.766-7.4,8.7-9.82",
    transform: "translate(-44.126 -132.362)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13532",
    "data-name": "Group 13532",
    transform: "translate(74.832 193.3)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13531",
    "data-name": "Group 13531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13530",
    "data-name": "Group 13530",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39786",
    "data-name": "Path 39786",
    d: "M126.074,326.825c3.392-1.66,7.392-1.918,11.289,1.755,4.481,4.223,5.735,10.556,5.793,16.325,0,0-4.838-19.669-16.325-18.162-.258.034-.51.061-.757.082",
    transform: "translate(-126.074 -325.662)",
    fill: "#a7a7a7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39787",
    "data-name": "Path 39787",
    d: "M126.119,413.268s3.71,15.969,3.776,19.991-11.462,8.331-14.4,8.015S102.58,432.365,101.942,431s4.586-15.989,5.8-17.281,17.85-2.766,18.377-.451",
    transform: "translate(-41.412 -167.475)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39788",
    "data-name": "Path 39788",
    d: "M132.686,376.334a1.529,1.529,0,0,1,.544,1.174c-.01,3.515-.037,15.484-2.083,18.111a7.725,7.725,0,0,1-1.546,1.453,19,19,0,0,1-13.736,2.91c-4.76-.845-10.85-5.518-10.731-6.813,0,0,.041-.439.113-1.221.252-2.759.9-9.807,1.575-17.111a1.544,1.544,0,0,1,.836-1.229,22.31,22.31,0,0,1,25.027,2.724",
    transform: "translate(-42.73 -150.761)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39789",
    "data-name": "Path 39789",
    d: "M135.12,339.041c-2.529,3.733-6.92,5.264-9.809,3.42s-3.18-6.365-.651-10.1,6.921-5.264,9.809-3.42,3.18,6.365.651,10.1",
    transform: "translate(-49.967 -133.378)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39790",
    "data-name": "Path 39790",
    d: "M141.756,309.974,130.861,330.36a1.349,1.349,0,0,0,2.2,1.534l14.11-15.825Z",
    transform: "translate(-53.122 -125.986)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39791",
    "data-name": "Path 39791",
    d: "M136.053,343.707a1.615,1.615,0,1,1-1.184-1.953,1.615,1.615,0,0,1,1.184,1.953",
    transform: "translate(-54.004 -138.883)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39792",
    "data-name": "Path 39792",
    d: "M136.69,343.925a1.5,1.5,0,1,1-1.1-1.812,1.5,1.5,0,0,1,1.1,1.812",
    transform: "translate(-54.356 -139.031)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39793",
    "data-name": "Path 39793",
    d: "M137.086,344.173a1.2,1.2,0,1,1-.883-1.457,1.2,1.2,0,0,1,.883,1.457",
    transform: "translate(-54.752 -139.279)",
    fill: "#559c33"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRobot500);
export default __webpack_public_path__ + "static/media/Error_Robot_500.38f745c16f38f7fd29d2b55ceae93bb7.svg";
export { ForwardRef as ReactComponent };